import HomePage from "../pages/Home";

export const App = () => {
  return (
    <HomePage/>
  );
};